import { passwordReset } from "@api/auth/passwordReset/api";
import { signIn } from "@api/auth/signIn/api";
import { signOut } from "@api/auth/signOut/api";
import { signUpApplicant } from "@api/auth/signUp/applicant/api";

export const auth = {
  signIn,
  passwordReset,
  signUpApplicant,
  signOut,
};
